import * as React from 'react';
import * as moment from 'moment';
import * as qs from 'qs';
import { Dispatch, connect } from 'react-redux';
import axios, { AxiosError, AxiosRequestConfig } from 'axios';
import { IActionCenterState, IActionCenterPendingSwapsResponse, IApplicationState, ActionCenterActionCreators, AppActionCreators, SwapActionCreators, ILogisticsOptionResponse, ILogisticsLookupDataResponse, FileActionCreators, IDutyOfficerResponse, IAppState, CenterActionCreators, RecipientActionCreators, DonorActionCreators, IAmbraDirectToViewerResponse } from '@nkr/store/index';
import { IPendingSwap, ILogistics, ILogisticsResponse, ILogisticsWithOption, IBaseResponse, ITransportType, IDutyOfficer } from '@nkr/models/index';
import { FileDocumentType, FileDocumentTypeDescription } from '@nkr/enums/index';
import { DropdownButton, MenuItem, OverlayTrigger, Alert, Popover, Button, Nav } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { downloadFile } from '@nkr/services/download-file';
import { SwapsToShow } from '../models';
import { NavWrapper, NavItemWrapper, PanelsWrapper } from './styles';
import { flattenSwapData, PendingSwapType, SwapReportType, getColumnDefinition } from "./pending-swaps-export-helper";
import { exportToXlsx } from '@nkr/utils/exportToExcel';
import LogisticsView from '@nkr/views/swap-management/swaps/swap-list/logistics/view';
import RequestScreeningXm from './modals/request-screening-xm';
import RequestFinalXm from './modals/request-final-xm';
import EmergencyNotification from './modals/emergency-notification';
import RequestSerologyKit from './modals/request-serology-kit';
import UploadFinalXm from './modals/upload-final-xm'
import LogisticsOption from './modals/logistics-option';
import UploadSerology from './modals/upload-serology';
import Patients from './patients';
import Donors from './donors';
import RemoteDonors from './remote-donors';
import Internals from './internals';

const timeframes = [
    { value: 3, title: 'Past 3 Months' },
    { value: 6, title: 'Past 6 Months' },
    { value: 9, title: 'Past 9 Months' },
    { value: 12, title: 'Past 12 Months' },
    { value: 999, title: 'All Prior Swaps' },
];

interface IServiceResponse {
    data: {
        IsSuccess: boolean,
        IsValidationError: boolean,
        Details: any,
        ErrorMessages: any[]
    }
}

interface IProps {
    centerId: number
}

interface IStateProps {
    app: IAppState,
    actionCenter: IActionCenterState,
    transportTypeList: ITransportType[]
}

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    showAlert: (title: string, message: string | JSX.Element) => void,
    getPendingSwaps: (centerId: number) => Promise<IActionCenterPendingSwapsResponse>,
    getPastTransplants: (centerId: number, startDate: string) => Promise<IActionCenterPendingSwapsResponse>,
    getLogisticsData: (donorId: number, recipientId: number) => Promise<ILogisticsResponse>,
    getLogisticsOption: (chainId: number, clusterNumber: number, positionNumber: number) => Promise<ILogisticsOptionResponse>,
    getLogisticsLookupData: () => Promise<ILogisticsLookupDataResponse>,
    requestFinalXm: (donorId: number, recipientId: number, bloodDrawDate: string) => Promise<IBaseResponse>,
    requestSerology: (donorId: number, recipientId: number, bloodDrawDate: string) => Promise<IBaseResponse>,
    saveSelectedLogisticsOption: (optionId: number) => Promise<IBaseResponse>,
    getFinalXmResults: (recipientId: number, donorId: number) => Promise<any>,
    uploadFinalXm: (donorId: number, recipientId: number, acceptable: number, rootCause: string, correctiveAction: string, initials: string, finalXmFile: File) => Promise<IBaseResponse>,
    uploadSerology: (donorId: number, recipientId: number, centerId: number, serologyFile: File) => Promise<IBaseResponse>,
    getCurrentDutyOfficer: () => Promise<IDutyOfficerResponse>,
    setDonorSwaps: (swaps: IPendingSwap[]) => void,
    downloadFormsAndChecklist: (donorId: number, recipientId: number) => Promise<any>,
    downloadFile: (docType: number, lookupId: number) => Promise<any>,
    sendEmergencyNotification: (recipientId: number, message: string, centerId: number, tempOrPermanent: number) => Promise<IBaseResponse>,
    sendScreeningXmEmail: (recipientId: number, donorId: number) => Promise<IBaseResponse>,
    getPatientOutcomes: (centerId: number) => Promise<any>,
    getAmbraLink: (donorId: number) => Promise<IAmbraDirectToViewerResponse>
}

type TProps = IStateProps & IDispatchProps & IProps;

interface IState {
    requestScreeningXm: {
        show: boolean,
        recipientId: number,
        donorId: number,
        donorAlias: string,
        donorCenterAlias: string,
        existingXm: boolean,
        status: string
    },
    requestFinalXm: {
        show: boolean,
        isInternalOrRemote: boolean,
        donorId: number,
        recipientId: number,
        donorAlias: string,
        donorCenterAlias: string,
        donorKidneyPickupDateTime: string,
        donorKidneyPickUpDateTimeTz: string,
        existingXm: boolean,
        status: string
    },
    emergencyNotification: {
        show: boolean,
        recipientId: number,
        swapNumber: string
    },
    requestSerologyKit: {
        show: boolean,
        donorId: number,
        recipientId: number,
        surgeryDate: string,
        isInternalOrRemote: boolean
    },
    uploadFinalXm: {
        show: boolean,
        donorId: number,
        recipientId: number,
        swap: string
    },
    uploadSerology: {
        show: boolean,
        donorId: number,
        recipientId: number,
        swap: string
    },
    logistics: {
        show: boolean,
        data: ILogistics | null
    },
    plans: {
        show: boolean,
        data: ILogisticsWithOption
    },
    show: SwapsToShow,
    pastSwapsLoaded: boolean,
    timeframe: number,
    dutyofficer: IDutyOfficer,
    setFade: string,
}

class PendingSwaps extends React.Component<TProps, IState> {
    readonly state: IState = {
        requestScreeningXm: {
            show: false,
            recipientId: 0,
            donorId: 0,
            donorAlias: '',
            donorCenterAlias: '',
            existingXm: false,
            status: ''
        },
        requestFinalXm: {
            show: false,
            isInternalOrRemote: false,
            recipientId: 0,
            donorId: 0,
            donorAlias: '',
            donorCenterAlias: '',
            donorKidneyPickupDateTime: '',
            donorKidneyPickUpDateTimeTz: '',
            existingXm: false,
            status: ''
        },
        emergencyNotification: {
            show: false,
            recipientId: 0,
            swapNumber: ''
        },
        requestSerologyKit: {
            show: false,
            recipientId: 0,
            donorId: 0,
            surgeryDate: '',
            isInternalOrRemote: false
        },
        uploadFinalXm: {
            show: false,
            recipientId: 0,
            donorId: 0,
            swap: ''
        },
        uploadSerology: {
            show: false,
            recipientId: 0,
            donorId: 0,
            swap: ''
        },
        logistics: {
            show: false,
            data: null
        },
        plans: {
            show: false,
            data: null
        },
        show: SwapsToShow.Pending,
        pastSwapsLoaded: false,
        timeframe: 3,
        dutyofficer: null,
        setFade: ''
    }

    dutyOfficerTimer: any;

    componentDidMount = () => {
        this.getData();
    }

    getData = () => {
        this.props.showLoading('Getting pending swaps, one moment please...').then(() => {
            Promise.all([
                this.props.getPendingSwaps(this.props.centerId),
                this.props.getLogisticsLookupData()
            ])
                .then(() => {
                    this.dutyOfficerTimer = window.setInterval(this.checkForDutyOfficer);
                    this.props.hideLoading();
                });
        });
    }

    checkForDutyOfficer = () => {
        const delay = ms => new Promise(res => setTimeout(res, ms));
        window.clearInterval(this.dutyOfficerTimer);

        this.props.getCurrentDutyOfficer().then(async response => {
            if (response.data.success) {
                if (this.state.dutyofficer !== null && (this.state.dutyofficer.id !== response.data.result.id)) {
                    this.setState({
                        setFade: 'fade-out'
                    });

                    await delay(2000);
                }

                this.setState({
                    dutyofficer: response.data.result,
                    setFade: 'fade-in'
                });
            }

            this.dutyOfficerTimer = window.setInterval(this.checkForDutyOfficer, 60000);
        });
    }

    exportSwapDataToExcel = () => {
        const swapData = this.state.show == SwapsToShow.Pending ? this.props.actionCenter.pendingSwaps : this.props.actionCenter.pastTransplants;
        const swapReportType = this.state.show == SwapsToShow.Pending ? SwapReportType.PendingSwaps : SwapReportType.PastSwaps;
        const excelFileName = this.state.show == SwapsToShow.Pending ? "PendingSwaps" : "PastSwaps";
        const sheetConfig = [
            {
                name: "Patient",
                data: flattenSwapData(swapData.recipientSwaps, this.props.centerId),
                columns: getColumnDefinition(PendingSwapType.Patient, swapReportType),
            },
            {
                name: "Donor",
                data: flattenSwapData(swapData.donorSwaps, this.props.centerId),
                columns: getColumnDefinition(PendingSwapType.Donor, swapReportType),
            },
            {
                name: "Remote Your Center",
                data: flattenSwapData(swapData.remoteDonorsYourCenter, this.props.centerId),
                columns: getColumnDefinition(PendingSwapType.DonorYourCenter, swapReportType),
            },
            {
                name: "Remote Other Centers",
                data: flattenSwapData(swapData.remoteDonorsOtherCenter, this.props.centerId),
                columns: getColumnDefinition(PendingSwapType.DonorOtherCenters, swapReportType),
            },
            {
                name: "Internal",
                data: flattenSwapData(swapData.internalSwaps, this.props.centerId),
                columns: getColumnDefinition(PendingSwapType.Internal, swapReportType),
            },
        ];

        exportToXlsx(excelFileName, sheetConfig);
    }

    getPastTransplantData = () => {
        let startDate = moment().add(this.state.timeframe * -1, 'months').format('YYYY-MM-DD');

        this.props.showLoading('Getting past transplants, one moment please...').then(() => {
            this.props.getPastTransplants(this.props.centerId, startDate)
                .then(response => {
                    this.props.hideLoading();
                });
        });
    }

    handleTabChange = (show: any) => {
        this.setState({
            show
        }, () => {
            if (this.state.show == SwapsToShow.Past && this.state.pastSwapsLoaded == false) {
                this.setState({
                    pastSwapsLoaded: true
                }, () => {
                    this.getPastTransplantData();
                });
            }
        });
    }

    handleTimeframeChange = (timeframe: number) => {
        this.setState({
            timeframe
        }, () => {
            this.getPastTransplantData();
        });
    }

    handleShowMap = (url: string) => {
        window.open(url);
    }

    handleShowGps = (url: string) => {
        window.open(url);
    }

    handleViewLogistics = (item: IPendingSwap) => {
        this.setState({
            logistics: {
                show: true,
                data: item.logistics
            }
        });
    }

    handleCloseLogistics = () => {
        this.setState({
            logistics: {
                show: false,
                data: null
            }
        });
    }

    handleViewCustomLogistics = (chainId: number, clusterNumber: number, positionNumber: number) => {
        this.props.showLoading('Fetching logistic options, one moment please...').then(() => {
            this.props.getLogisticsOption(chainId, clusterNumber, positionNumber).then((response: ILogisticsOptionResponse) => {
                var { success, results } = response.data;

                if (success) {
                    this.setState({
                        plans: {
                            show: true,
                            data: results
                        }
                    }, () => {
                        this.props.hideLoading();
                    });
                }
            });
        });
    }

    handleSaveSelectedLogisticsOption = (planId: number) => {
        this.props.showLoading('Saving selected logistics option, one moment please...').then(() => {
            this.props.saveSelectedLogisticsOption(planId).then(response => {
                this.setState({
                    plans: {
                        show: false,
                        data: null
                    }
                }, () => {
                    this.props.getPendingSwaps(this.props.centerId).then((response: IActionCenterPendingSwapsResponse) => {
                        this.props.hideLoading();
                    });
                });
            });
        });
    }

    handleCloseLogisticsPlans = () => {
        this.setState({
            plans: {
                show: false,
                data: null
            }
        });
    }

    handleRequestScreeningXm = (swap: IPendingSwap, existingXm: boolean, status: string) => {
        this.setState({
            requestScreeningXm: {
                show: true,
                recipientId: swap.recipient.id,
                donorId: swap.donor.id,
                donorAlias: swap.donor.alias,
                donorCenterAlias: swap.donor.center,
                existingXm,
                status
            }
        });
    }

    handleSendRequestForScreeningXm = () => {
        this.setState({
            requestScreeningXm: { ...this.state.requestScreeningXm, show: false }
        }, () => {
            this.props.showLoading('Sending screening XM request, one moment please...').then(() => {
                let { recipientId, donorId } = this.state.requestScreeningXm;

                this.props.sendScreeningXmEmail(recipientId, donorId)
                    .then(response => {
                        if (response.data.success) {
                            toast.success('Screening XM request sent successfully');
                        }
                    })
                    .finally(() => {
                        this.props.hideLoading();
                    })
            });
        });
    }

    handleCancelRequestForScreeningXm = () => {
        this.setState({
            requestScreeningXm: { ...this.state.requestScreeningXm, show: false }
        });
    }

    handleRequestFinalXm = (swap: IPendingSwap, existingXm: boolean, status: string, isInternalOrRemote: boolean = false) => {
        this.setState({
            requestFinalXm: {
                show: true,
                isInternalOrRemote,
                recipientId: swap.recipient.id,
                donorId: swap.donor.id,
                donorAlias: swap.donor.alias,
                donorCenterAlias: swap.donor.rdnCenter?.length > 0 ? swap.donor.rdnCenter : swap.donor.center,
                donorKidneyPickupDateTime: swap.logistics.kidneyPickupDateTime,
                donorKidneyPickUpDateTimeTz: swap.logistics.kidneyPickupDateTimeTz,
                existingXm,
                status
            }
        });
    }

    handleSendRequestForFinalXm = (bloodDrawDate: string) => {
        this.setState({
            requestFinalXm: { ...this.state.requestFinalXm, show: false, isInternalOrRemote: false }
        }, () => {
            this.props.showLoading('Sending final XM request, one moment please...').then(() => {
                let { donorId, recipientId } = this.state.requestFinalXm;

                this.props.requestFinalXm(donorId, recipientId, bloodDrawDate).then(
                    response => {
                        if (response.data.success) {
                            toast.success('Final XM Requested Successfully');
                        } else {
                            toast.error('Could not request the final XM: ' + response.data.message);
                        }

                        this.props.hideLoading();
                    }
                )
            });
        });
    }

    handleCancelRequestForFinalXm = () => {
        this.setState({
            requestFinalXm: { ...this.state.requestFinalXm, show: false, isInternalOrRemote: false }
        });
    }

    handleEmergencyNotification = (swap: IPendingSwap) => {
        this.setState({
            emergencyNotification: {
                show: true,
                recipientId: swap.recipient.id,
                swapNumber: swap.chainId + '/' + swap.clusterNumber
            }
        });
    }

    handleSendEmergencyNotification = (message: string, temporaryOrPermanent: number) => {
        this.setState({
            emergencyNotification: { ...this.state.emergencyNotification, show: false }
        }, () => {
            this.props.showLoading('Sending emergency notification, one moment please...').then(() => {
                let recipientId = this.state.emergencyNotification.recipientId;

                this.props.sendEmergencyNotification(recipientId, message, this.props.centerId, temporaryOrPermanent)
                    .then(response => {
                        if (response.data.success) {
                            toast.success('Emergency notification sent successfully');
                        }
                    })
                    .finally(() => {
                        this.props.hideLoading();
                    });
            });
        });
    }

    handleCancelEmergencyNotification = () => {
        this.setState({
            emergencyNotification: { ...this.state.emergencyNotification, show: false }
        });
    }

    handleUploadFinalXm = (swap: IPendingSwap) => {
        this.setState({
            uploadFinalXm: {
                show: true,
                recipientId: swap.recipient.id,
                donorId: swap.donor.id,
                swap: `${swap.chainId}/${swap.clusterNumber}/${swap.positionNumber}`
            }
        });
    }

    handleUploadSerology = (swap: IPendingSwap) => {
        this.setState({
            uploadSerology: {
                show: true,
                recipientId: swap.recipient.id,
                donorId: swap.donor.id,
                swap: `${swap.chainId}/${swap.clusterNumber}/${swap.positionNumber}`
            }
        });
    }

    handleFormsAndChecklistsDownload = (donorId: number, recipientId: number) => {
        this.props.downloadFormsAndChecklist(donorId, recipientId)
            .then((response: any) => {
                downloadFile(response.data, `form-and-checklists-${recipientId}-${donorId}.pdf`, 'application/pdf');
            });
    }

    handleSendRequestForUploadSerology = (serologyFile: File) => {
        let { donorId, recipientId } = this.state.uploadSerology;

        this.setState({
            uploadSerology: { ...this.state.uploadSerology, show: false }
        }, () => {
            this.props.showLoading('Saving Serology Results, one moment please...').then(() => {
                this.props.uploadSerology(donorId, recipientId, this.props.centerId, serologyFile)
                    .then(response => {
                        if (response.data.success) {
                            toast.success('Serology Uploaded Successfully');
                        } else {
                            toast.error('Could not upload the Serology file');
                        }
                    })
                    .finally(() => {
                        this.props.hideLoading();
                    });
            });
        });
    }

    handleSendRequestForUploadFinalXm = (acceptable: number, rootCause: string, correctiveAction: string, initials: string, finalXmFile: File) => {
        let { donorId, recipientId } = this.state.uploadFinalXm;

        this.setState({
            uploadFinalXm: { ...this.state.uploadFinalXm, show: false }
        }, () => {
            this.props.showLoading('Saving FinalXM Results, one moment please...').then(() => {
                this.props.uploadFinalXm(donorId, recipientId, acceptable, rootCause, correctiveAction, initials, finalXmFile).then(
                    response => {
                        if (response.data.success) {
                            toast.success('Final XM Uploaded Successfully');
                        } else {
                            toast.error('Could not upload the final XM: ' + response.data.message);
                        }
                    }
                )
                this.props.hideLoading();
            });
        });
    }

    handleCancelUploadFinalXm = () => {
        this.setState({
            uploadFinalXm: { ...this.state.uploadFinalXm, show: false }
        });
    }

    handleCancelUploadSerology = () => {
        this.setState({
            uploadSerology: { ...this.state.uploadSerology, show: false }
        });
    }

    handleRequestSerologyKit = (swap: IPendingSwap, isInternalOrRemote: boolean = false) => {
        this.setState({
            requestSerologyKit: {
                show: true,
                recipientId: swap.recipient.id,
                donorId: swap.donor.id,
                surgeryDate: swap.donor.kidneyPickupDateTime,
                isInternalOrRemote: isInternalOrRemote
            }
        });
    }

    handleSendRequestForSerologyKit = (bloodDrawDate: string) => {
        this.setState({
            requestSerologyKit: { ...this.state.requestSerologyKit, show: false }
        }, () => {
            this.props.showLoading('Sending Serology Kit request, one moment please...').then(() => {
                let { donorId, recipientId } = this.state.requestSerologyKit;

                this.props.requestSerology(donorId, recipientId, bloodDrawDate).then(
                    response => {
                        if (response.data.success) {
                            toast.success('Serology Requested Successfully');
                        } else {
                            toast.error('Could not request the Serology: ' + response.data.message);
                        }

                        this.props.hideLoading();
                    }
                )
            });
        });
    }

    handleCancelRequestForSerologyKit = () => {
        this.setState({
            requestSerologyKit: { ...this.state.requestSerologyKit, show: false }
        });
    }

    handleGetFinalXmResults = (recipientId: number, donorId: number, fileName: string) => {
        fileName = 'finalxm_' + donorId + '_' + recipientId + '.pdf';

        this.props.getFinalXmResults(recipientId, donorId).then((response: any) => {
            downloadFile(response.data, fileName, 'application/pdf');
        });
    }

    handleGetFile = (docType: FileDocumentType, donorId: number) => {
        this.props.downloadFile(docType, donorId).then((response: any) => {
            downloadFile(response.data, `${FileDocumentTypeDescription[docType]}.pdf`, response.headers.contentType)
        }).catch((error: IBaseResponse) => {
            toast.error("Unable to download file at this time.  Please contact support.");
        })
    }

    handleGetPatientOutcomes = (centerId: number) => {
        this.props.getPatientOutcomes(centerId)
            .then((response: any) => {
                downloadFile(response.data, `patient-outcomes-${centerId}.pdf`, 'application/pdf');
            });
    }

    handleViewCtScan = (donorId: number) => {
        this.props.getAmbraLink(donorId).then(response => {
            window.open(response.data.results, '_blank');
        });
    }

    sendWebServiceRequest = (method: string, data: any, url: string, successMessage: string) => {
        var postConfig: AxiosRequestConfig = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            withCredentials: true
        };

        let d = qs.stringify(
            {
                method,
                params: data
            });

        return axios.post(url, d, postConfig)
            .then((response: IServiceResponse) => {
                this.props.hideLoading();

                if (response.data.IsSuccess) {
                    toast.success(successMessage);
                } else {
                    this.props.showAlert(
                        'Alert!',
                        <div>
                            <div style={{ marginBottom: 20 }}>A processing error occurred:</div>
                            <div style={{ marginLeft: 20 }}>{response.data.ErrorMessages}</div>
                        </div>);
                }
            }).catch((error: AxiosError) => {
                this.props.hideLoading();
                this.props.showAlert('Fatal', error.message);
            });
    }

    render = () => {
        const widths = [
            '6%', // 0-swap status 
            '5%', // 1-swap #
            '5%', // 2-type
            '',   // 3-recipient
            '',   // 4-donor center
            '',   // 5-donor alias
            '7%', // 6-calls
            '5%', // 7-tubes
            '10%', // 8-logistics/gps
            '5%', // 9-transport cost
            '5%', // 10-target surgery date
            '7%', // 11-scheduled delivery
            '7%', // 12-deadline
            '7%'  // 13-actions
        ];

        const swaps = this.state.show == 1 ? this.props.actionCenter.pendingSwaps : this.props.actionCenter.pastTransplants;
        const currentTimeframe = timeframes.find(x => x.value == this.state.timeframe);

        const dutyOfficerOverlay = (
            <Popover id='alertpop' bsStyle='warning' style={{ background: '#fcf8e3', width: '300px' }} >
                <div>{this.state.dutyofficer ? this.state.dutyofficer.name : 'Loading...'}</div>
                <div>{this.state.dutyofficer ? this.state.dutyofficer.phoneNumber : '...'}</div>
                <div>{this.state.dutyofficer ? this.state.dutyofficer.email : '...'}</div><br />
                <div style={{ fontSize: 'small', textAlign: 'left' }}>You can always contact NKR Logistics via <br />email (nkrlogistics@kidneyregistry.org) if <br />
                    you cannot reach &nbsp;<b>{this.state.dutyofficer ? this.state.dutyofficer.name : 'Loading...'}</b></div>
            </Popover>
        );

        return (
            <>
                <div className='container-fluid'>
                    <div className='row'>
                        <div className='col-xs-12'>
                            <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
                                <div><h4 style={{ margin: 0 }}>Swaps</h4></div>

                                <div>
                                    <Alert bsStyle='info' style={{ margin: 0, paddingTop: 3, paddingBottom: 3, textAlign: 'center' }}>
                                        For any questions regarding an actively moving kidney please contact the current officer on duty&nbsp;
                                        <OverlayTrigger trigger='click' placement='bottom' overlay={dutyOfficerOverlay} rootClose defaultOverlayShown={false}>
                                            <Button bsSize='xs' bsStyle='success' onClick={(e: any) => e.stopPropagation()}>
                                                <div className={this.state.setFade}>{this.state.dutyofficer ? this.state.dutyofficer.name : 'Loading Officer...'}</div>
                                            </Button>
                                        </OverlayTrigger>
                                    </Alert>
                                </div>

                                <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                    <NavWrapper style={{ marginRight: 15 }}>
                                        <div>
                                            <Nav bsStyle='pills' bsSize='sm' className='acc-pills' activeKey={this.state.show} onSelect={(tab: any) => this.handleTabChange(tab)}>
                                                <NavItemWrapper eventKey={1}>Pending Swaps</NavItemWrapper>
                                                <NavItemWrapper eventKey={2}>Past Swaps</NavItemWrapper>
                                            </Nav>
                                        </div>
                                    </NavWrapper>

                                    {this.state.show == SwapsToShow.Past && (
                                        <div className='text-right'>
                                            <DropdownButton bsSize='sm' title={currentTimeframe.title} id='time-frame'>
                                                {timeframes.map((timeframe, index) =>
                                                    <MenuItem key={index} eventKey={timeframe.value} onSelect={(eventKey) => this.handleTimeframeChange(eventKey)}>{timeframe.title}</MenuItem>
                                                )}
                                            </DropdownButton>
                                        </div>
                                    )}
                                </div>

                                <div>
                                    <Button bsSize='medium' bsStyle='default' onClick={() => this.exportSwapDataToExcel() }>Export CSV</Button>
                                </div>
                            </div>

                            <PanelsWrapper>
                                <Patients
                                    list={swaps.recipientSwaps}
                                    centerId={this.props.centerId}
                                    show={this.state.show}
                                    currentTimeframe={currentTimeframe}
                                    widths={widths}
                                    onRequestScreeningXm={this.handleRequestScreeningXm}
                                    onRequestFinalXm={this.handleRequestFinalXm}
                                    onEmergencyNotification={this.handleEmergencyNotification}
                                    onRequestSerologyKit={this.handleRequestSerologyKit}
                                    onUploadFinalXm={this.handleUploadFinalXm}
                                    onUploadSerology={this.handleUploadSerology}
                                    onViewLogistics={this.handleViewLogistics}
                                    onShowMap={this.handleShowMap}
                                    onShowGps={this.handleShowGps}
                                    onViewCustomLogistics={this.handleViewCustomLogistics}
                                    onGetFinalXmResults={this.handleGetFinalXmResults}
                                    onDownloadFormsAndChecklists={this.handleFormsAndChecklistsDownload}
                                    onGetFile={this.handleGetFile}
                                    onGetPatientOutcomes={this.handleGetPatientOutcomes}
                                    onViewCtScan={this.handleViewCtScan} />

                                <Donors
                                    list={swaps.donorSwaps}
                                    centerId={this.props.centerId}
                                    show={this.state.show}
                                    currentTimeframe={currentTimeframe}
                                    widths={widths}
                                    onRequestScreeningXm={this.handleRequestScreeningXm}
                                    onRequestFinalXm={this.handleRequestFinalXm}
                                    onEmergencyNotification={this.handleEmergencyNotification}
                                    onRequestSerologyKit={this.handleRequestSerologyKit}
                                    onUploadFinalXm={this.handleUploadFinalXm}
                                    onUploadSerology={this.handleUploadSerology}
                                    onViewLogistics={this.handleViewLogistics}
                                    onShowMap={this.handleShowMap}
                                    onShowGps={this.handleShowGps}
                                    onViewCustomLogistics={this.handleViewCustomLogistics}
                                    onGetFinalXmResults={this.handleGetFinalXmResults}
                                    onDownloadFormsAndChecklists={this.handleFormsAndChecklistsDownload}
                                    onGetFile={this.handleGetFile}
                                    onGetPatientOutcomes={this.handleGetPatientOutcomes}
                                    onViewCtScan={this.handleViewCtScan} />

                                <RemoteDonors
                                    list={swaps.remoteDonorsYourCenter}
                                    centerId={this.props.centerId}
                                    show={this.state.show}
                                    currentTimeframe={currentTimeframe}
                                    widths={widths}
                                    title='Remote Donors Donating at Your Center'
                                    onRequestScreeningXm={this.handleRequestScreeningXm}
                                    onRequestFinalXm={this.handleRequestFinalXm}
                                    onEmergencyNotification={this.handleEmergencyNotification}
                                    onRequestSerologyKit={this.handleRequestSerologyKit}
                                    onUploadFinalXm={this.handleUploadFinalXm}
                                    onUploadSerology={this.handleUploadSerology}
                                    onViewLogistics={this.handleViewLogistics}
                                    onShowMap={this.handleShowMap}
                                    onShowGps={this.handleShowGps}
                                    onViewCustomLogistics={this.handleViewCustomLogistics}
                                    onGetFinalXmResults={this.handleGetFinalXmResults}
                                    onDownloadFormsAndChecklists={this.handleFormsAndChecklistsDownload}
                                    onGetFile={this.handleGetFile}
                                    onGetPatientOutcomes={this.handleGetPatientOutcomes}
                                    onViewCtScan={this.handleViewCtScan} />

                                <RemoteDonors
                                    list={swaps.remoteDonorsOtherCenter}
                                    centerId={this.props.centerId}
                                    show={this.state.show}
                                    currentTimeframe={currentTimeframe}
                                    widths={widths}
                                    title='Remote Donors Donating at Other Centers'
                                    onRequestScreeningXm={this.handleRequestScreeningXm}
                                    onRequestFinalXm={this.handleRequestFinalXm}
                                    onEmergencyNotification={this.handleEmergencyNotification}
                                    onRequestSerologyKit={this.handleRequestSerologyKit}
                                    onUploadFinalXm={this.handleUploadFinalXm}
                                    onUploadSerology={this.handleUploadSerology}
                                    onViewLogistics={this.handleViewLogistics}
                                    onShowMap={this.handleShowMap}
                                    onShowGps={this.handleShowGps}
                                    onViewCustomLogistics={this.handleViewCustomLogistics}
                                    onGetFinalXmResults={this.handleGetFinalXmResults}
                                    onDownloadFormsAndChecklists={this.handleFormsAndChecklistsDownload}
                                    onGetFile={this.handleGetFile}
                                    onGetPatientOutcomes={this.handleGetPatientOutcomes}
                                    onViewCtScan={this.handleViewCtScan} />

                                <Internals
                                    list={swaps.internalSwaps}
                                    centerId={this.props.centerId}
                                    show={this.state.show}
                                    currentTimeframe={currentTimeframe}
                                    widths={widths}
                                    onRequestScreeningXm={this.handleRequestScreeningXm}
                                    onRequestFinalXm={this.handleRequestFinalXm}
                                    onEmergencyNotification={this.handleEmergencyNotification}
                                    onRequestSerologyKit={(swap) => this.handleRequestSerologyKit(swap, true)}
                                    onUploadFinalXm={this.handleUploadFinalXm}
                                    onUploadSerology={this.handleUploadSerology}
                                    onViewLogistics={this.handleViewLogistics}
                                    onShowMap={this.handleShowMap}
                                    onShowGps={this.handleShowGps}
                                    onViewCustomLogistics={this.handleViewCustomLogistics}
                                    onGetFinalXmResults={this.handleGetFinalXmResults}
                                    onDownloadFormsAndChecklists={this.handleFormsAndChecklistsDownload}
                                    onGetFile={this.handleGetFile}
                                    onGetPatientOutcomes={this.handleGetPatientOutcomes}
                                    onViewCtScan={this.handleViewCtScan} />
                            </PanelsWrapper>
                        </div>
                    </div>
                </div>

                <RequestScreeningXm
                    show={this.state.requestScreeningXm.show}
                    existingXm={this.state.requestScreeningXm.existingXm}
                    status={this.state.requestScreeningXm.status}
                    donorAlias={this.state.requestScreeningXm.donorAlias}
                    donorCenterAlias={this.state.requestScreeningXm.donorCenterAlias}
                    onSend={this.handleSendRequestForScreeningXm}
                    onCancel={this.handleCancelRequestForScreeningXm}
                />

                <RequestFinalXm
                    show={this.state.requestFinalXm.show}
                    isInternalOrRemote={this.state.requestFinalXm.isInternalOrRemote}
                    existingXm={this.state.requestFinalXm.existingXm}
                    status={this.state.requestFinalXm.status}
                    donorAlias={this.state.requestFinalXm.donorAlias}
                    donorCenterAlias={this.state.requestFinalXm.donorCenterAlias}
                    donorKidneyPickUpDateTime={this.state.requestFinalXm.donorKidneyPickupDateTime}
                    donorKidneyPickUpDateTimeTz={this.state.requestFinalXm.donorKidneyPickUpDateTimeTz}
                    onSend={this.handleSendRequestForFinalXm}
                    onCancel={this.handleCancelRequestForFinalXm}
                />

                <EmergencyNotification
                    show={this.state.emergencyNotification.show}
                    swapNumber={this.state.emergencyNotification.swapNumber}
                    onSend={this.handleSendEmergencyNotification}
                    onCancel={this.handleCancelEmergencyNotification}
                />

                <RequestSerologyKit
                    show={this.state.requestSerologyKit.show}
                    surgeryDate={this.state.requestSerologyKit.surgeryDate}
                    isInternalOrRemote={this.state.requestSerologyKit.isInternalOrRemote}
                    onSend={this.handleSendRequestForSerologyKit}
                    onCancel={this.handleCancelRequestForSerologyKit}
                />

                <UploadFinalXm
                    show={this.state.uploadFinalXm.show}
                    swap={this.state.uploadFinalXm.swap}
                    onSend={this.handleSendRequestForUploadFinalXm}
                    onCancel={this.handleCancelUploadFinalXm}
                />

                <UploadSerology
                    show={this.state.uploadSerology.show}
                    swap={this.state.uploadSerology.swap}
                    onSend={this.handleSendRequestForUploadSerology}
                    onCancel={this.handleCancelUploadSerology}
                />

                <LogisticsView
                    show={this.state.logistics.show}
                    data={this.state.logistics.data}
                    fontSize={13}
                    onClose={this.handleCloseLogistics}
                />

                <LogisticsOption
                    show={this.state.plans.show}
                    data={this.state.plans.data}
                    transportTypes={this.props.transportTypeList}
                    onSave={this.handleSaveSelectedLogisticsOption}
                    onCancel={this.handleCloseLogisticsPlans}
                />
            </>
        )
    }
}

const mapStateToProps = (appState: IApplicationState, ownProps: IProps): IStateProps => {
    return {
        app: appState.app,
        actionCenter: appState.actionCenter,
        transportTypeList: appState.swaps.transportTypeList
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        showAlert: (title, message) => {
            return dispatch(AppActionCreators.showAlert(title, message));
        },
        getPendingSwaps: (centerId) => {
            return dispatch(ActionCenterActionCreators.getPendingSwaps(centerId));
        },
        getPastTransplants: (centerId, startDate) => {
            return dispatch(ActionCenterActionCreators.getPastTransplants(centerId, startDate));
        },
        getLogisticsData: (donorId, recipientId) => {
            return dispatch(SwapActionCreators.getLogisticsDataByDonorRecipient(donorId, recipientId));
        },
        getLogisticsOption: (chainId, clusterNumber, positionNumber) => {
            return dispatch(SwapActionCreators.getLogisticsOption(chainId, clusterNumber, positionNumber))
        },
        getLogisticsLookupData: () => {
            return dispatch(SwapActionCreators.getLogisticsLookupData());
        },
        saveSelectedLogisticsOption: (optionId) => {
            return dispatch(SwapActionCreators.saveSelectedLogisticsOption(optionId))
        },
        getFinalXmResults: (recipientId, donorId) => {
            return dispatch(ActionCenterActionCreators.getFinalXmResults(recipientId, donorId));
        },
        requestFinalXm: (donorId, recipientId, bloodDrawDate) => {
            return dispatch(ActionCenterActionCreators.requestFinalXm(donorId, recipientId, bloodDrawDate));
        },
        requestSerology: (donorId, recipientId, bloodDrawDate) => {
            return dispatch(ActionCenterActionCreators.requestSerology(donorId, recipientId, bloodDrawDate));
        },
        uploadFinalXm: (donorId, recipientId, acceptable, rootCause, correctiveAction, initials, finalXmFile) => {
            return dispatch(ActionCenterActionCreators.uploadFinalXm(donorId, recipientId, acceptable, rootCause, correctiveAction, initials, finalXmFile));
        },
        uploadSerology: (donorId, recipientId, centerId, serologyFile) => {
            return dispatch(ActionCenterActionCreators.uploadSerology(donorId, recipientId, centerId, serologyFile));
        },
        getCurrentDutyOfficer: () => {
            return dispatch(SwapActionCreators.getCurrentDutyOfficer());
        },
        setDonorSwaps: (swaps: IPendingSwap[]) => {
            dispatch(ActionCenterActionCreators.setDonorSwaps(swaps));
        },
        downloadFormsAndChecklist: (donorId, recipientId) => {
            return dispatch(FileActionCreators.getFormsAndChecklists(donorId, recipientId))
        },
        downloadFile: (docType, id) => {
            return dispatch(FileActionCreators.downloadFile(docType, id))
        },
        sendEmergencyNotification: (recipientId, message, centerId, tempOrPermanent) => {
            return dispatch(CenterActionCreators.sendEmergencyNotification(recipientId, message, centerId, tempOrPermanent));
        },
        sendScreeningXmEmail: (recipientId, donorId) => {
            return dispatch(CenterActionCreators.sendScreeningXmEmail(recipientId, donorId));
        },
        getPatientOutcomes: (centerId) => {
            return dispatch(CenterActionCreators.getPatientOutcomes(centerId));
        },
        getAmbraLink: (donorId) => {
            return dispatch(DonorActionCreators.getAmbraLink(donorId));
        },
    };
}

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(PendingSwaps);